var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrainyagent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6768 14.6691C14.6768 17.3608 13.2263 19.7155 11.0657 20.989L9.1203 19.0435C8.65393 18.5771 8.01623 18.3373 7.35569 18.3373C9.37347 18.3297 11.0105 16.6907 11.0105 14.6691C11.0105 12.6475 9.37728 11.0105 7.3595 11.001H7.39567C8.02765 11.0105 8.6387 10.7782 9.08413 10.3309L11.0676 8.34738C13.2301 9.62277 14.6787 11.9775 14.6787 14.6672L14.6768 14.6691Z",
    fill: "#458FE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1184 19.0435L11.0638 20.989C9.96739 21.6381 8.68819 22.0093 7.32143 22.0055C3.41912 21.9979 0.162119 18.8703 0.00602629 14.9699C-0.161488 10.7801 3.18498 7.33088 7.33856 7.33088C8.69961 7.33088 9.9731 7.70017 11.0638 8.34738L9.08033 10.3309C8.63299 10.7782 8.02194 11.0086 7.38996 11.001C7.37854 11.001 7.36712 11.001 7.35569 11.001C5.4921 10.9914 3.93499 12.3354 3.69894 14.1856C3.41151 16.428 5.15137 18.3392 7.33666 18.3392C7.34047 18.3392 7.34237 18.3392 7.34618 18.3392C8.00862 18.3392 8.64822 18.5771 9.11649 19.0454L9.1184 19.0435Z",
    fill: "#AFE4FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5703 15.7066L17.2695 22.0074C15.8361 20.574 15.8361 18.2516 17.2695 16.8183L22.0132 12.0746L23.5703 13.6317C24.1432 14.2047 24.1432 15.1336 23.5703 15.7066Z",
    fill: "#458FE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66849 3.6608V8.31121C1.47748 9.58089 0.000315589 11.9527 0.000315589 14.6691V-0.00737C2.02761 -0.00737 3.66849 1.63541 3.66849 3.6608Z",
    fill: "#AFE4FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5703 15.7066L22.0132 17.2637L17.2695 12.52C15.8361 11.0866 15.8361 8.76426 17.2695 7.33088L23.5703 13.6317C24.1432 14.2047 24.1432 15.1336 23.5703 15.7066Z",
    fill: "#AFE4FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.456 18.8208C21.3164 17.9604 21.3164 16.567 20.456 15.7066L22.0132 17.2637L20.456 18.8208Z",
    fill: "#AFE4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainyagent);
export default __webpack_public_path__ + "static/media/brainyagent.25faa7bc2eedac35903a866220656867.svg";
export { ForwardRef as ReactComponent };